/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Event_AfterInputs */

const en_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert event after`)
};

const fr_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer un événement après`)
};

const de_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge das Ereignis nach dem`)
};

const it_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento dopo`)
};

const ru_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие после`)
};

const es_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento después`)
};

const zh_cn2_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在插入事件后`)
};

const ja_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後にイベントを挿入`)
};

const hi_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसके बाद इवेंट डालें`)
};

const pt_pt2_insert_event_after = /** @type {(inputs: Insert_Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento após`)
};

/**
* | output |
* | --- |
* | "Insert event after" |
*
* @param {Insert_Event_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_event_after = /** @type {((inputs?: Insert_Event_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Event_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_event_after(inputs)
	if (locale === "de") return de_insert_event_after(inputs)
	if (locale === "it") return it_insert_event_after(inputs)
	if (locale === "ru") return ru_insert_event_after(inputs)
	if (locale === "es") return es_insert_event_after(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_event_after(inputs)
	if (locale === "ja") return ja_insert_event_after(inputs)
	if (locale === "hi") return hi_insert_event_after(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_event_after(inputs)
	return en_insert_event_after(inputs)
});